import { render, staticRenderFns } from "./DialogAnteprima.vue?vue&type=template&id=64091390&"
import script from "./DialogAnteprima.vue?vue&type=script&lang=js&"
export * from "./DialogAnteprima.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports